import { ChangeDetectorRef, DestroyRef, Directive, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IRequestCallback } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { Wishlist } from '@df/session/api/wishlist/wishlist';

@Directive()
export abstract class WishlistMoveFromBasketComponentDef {
    /**
     * Basket quote item id (not product id)
     */
    @Input()
    basketItems: BasketItem | BasketItem[];

    /**
     * Retrieve status model for request processing info
     * @type {object}
     */
    status = new Status();

    protected destroyRef = inject(DestroyRef);

    constructor(
        protected _ref: ChangeDetectorRef,
        protected wishlist: Wishlist
    ) {}

    ngOnInit() {
        this.wishlist.wishlistUpdateSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this._ref.detectChanges());
    }

    moveFromBasket(onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        return this.wishlist.moveFromBasket(this.status, this.basketItems, onSuccess, onError);
    }
}
